import {WorkOrderPriority} from "../store/data/entities/work-order";
import { DateTime } from 'luxon';

const dateFormat = 'dd LLL yy'
const dateTimeFormat = 'dd LLL yy HH:mm'
const timeFormat = 'HH:mm'

export function humanizeDate(date: string, showTime?: boolean): string {
  const parsedDate = DateTime.fromISO(date);
  if (!parsedDate.isValid) return 'N/A';

  const format = showTime ? dateTimeFormat : dateFormat;
  const formattedDate = parsedDate
    .setZone(DateTime.local().zoneName)
    .toFormat(format);

  return formattedDate.toUpperCase();
}

export function humanizeTime(dateTime: string): string {
  const parsedDateTime = DateTime.fromISO(dateTime);
  return parsedDateTime.isValid ? parsedDateTime.toFormat(timeFormat) : 'N/A';
}

export function humanizeBoolean(value: boolean): string {
  return value ? 'Yes' : 'No'
}

export function humanizeCurrency(value: number, locale: Intl.LocalesArgument = 'en-GB', currency: string = 'GBP'): string {
  return value.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
  })
}

export function humanizeString(value: string, casing: 'upper' | 'lower' | 'title'): string {
  switch (casing) {
    case 'upper':
      return value.toUpperCase();
    case 'lower':
      return value.toLowerCase();
    case 'title':
      return value.replace(/\w\S*/g, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
      );
    default:
      return value;
  }
}

export const humanizeEnum = (value: string): string => {
  if (!value) return '';
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .trim();
};

export const humanizePastDate = (date: string | undefined, fallback: string = 'N/A') => {
  if (!date) return fallback;

  const parsedDate = DateTime.fromISO(date);
  if (!parsedDate.isValid) {
    return fallback;
  }

  const now = DateTime.now().startOf('day');
  const comparisonDate = parsedDate.startOf('day');

  const dayDifference = comparisonDate.diff(now, 'days').days;

  if (dayDifference === 0) {
    return 'Today';
  }

  if (dayDifference === 1) {
    return 'Tomorrow';
  }

  if (dayDifference === -1) {
    return 'Yesterday';
  }

  return parsedDate.toRelative({ base: DateTime.now() });
};


export const humanizeWorkOrderPriority = (value: WorkOrderPriority)=> {
  if (value === WorkOrderPriority.Standard) return 'STD';
  if (value === WorkOrderPriority.Important) return 'IMP';
  if (value === WorkOrderPriority.Urgent) return 'URG';
  if (value === WorkOrderPriority.Emergency) return 'EMER';
  return 'N/A';
}
